import { useTranslation } from 'react-i18next';

import { Card } from '@codes/ui-kit/components/ui/card';
import { Check } from 'lucide-react';

import { Button } from '@codes/ui-kit';

interface KeyCardProps {
    title: string;
    description: string;
    isRegistered: boolean;
    onManage: () => void;
    icon: React.ComponentType<{ className?: string }>;
}

export const KeyCard = ({ title, description, isRegistered, onManage, icon: Icon }: KeyCardProps) => {
    const { t } = useTranslation();

    return (
        <Card className="p-4 md:p-6 rounded-xl md:rounded-2xl hover:shadow-md transition-shadow">
            <div className="flex flex-col sm:flex-row items-start justify-between gap-4">
                <div className="flex gap-3 md:gap-4 flex-1 min-w-0 w-full sm:w-auto">
                    <div className="w-10 h-10 rounded-lg bg-point/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="w-5 h-5 text-point" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                            <h3 className="text-sm md:text-base font-semibold text-gray-900 dark:text-white">
                                {title}
                            </h3>
                            {isRegistered && (
                                <div className="flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                                    <Check className="w-3 h-3" />
                                    <span>{t('common.registered')}</span>
                                </div>
                            )}
                        </div>
                        <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400 line-clamp-2">
                            {description}
                        </p>
                    </div>
                </div>
                <Button
                    variant={isRegistered ? 'outline' : 'default'}
                    size="sm"
                    onClick={onManage}
                    className="w-full sm:w-auto"
                >
                    {isRegistered ? t('common.manage') : t('common.register')}
                </Button>
            </div>
        </Card>
    );
};
